import React, { useState } from "react";
import Form from "./Form";
import { apiUrl } from "../../../utils/apiUrl";
import { postRequest } from "../../../utils/request";
import { toast } from "../../../utils/helpers";

const Create =  ({getUsers, filters, toggle, sucursales, usuario, almacenes, cuentas}) => {
    const [errors, setErrors] = useState({});

    const createUser = async event => {
        event.preventDefault();

        const data = new FormData(event.target);
        const { es_vendedor, empleado_id, ...rest } = Object.fromEntries(data.entries());

        if (es_vendedor && !empleado_id) {
            toast('Empleado es requerido', 'error');
            return
        }

        if (!rest['sucursales[]']) {
             toast('Sucursales es requerido', 'error');
            return
        }

        const response = await postRequest(apiUrl("usuarios"), data);

        if (response.success) {
            let query = Object.keys(filters).map((fil) => {
                return `${fil}=${filters[fil]}`;
            });

            getUsers("usuarios?limit=15&" + query.join("&"));
            toggle();
        }
        if (response.code === 422) {
            setErrors(response.data.message);
        }
    };

    return (
        <form method='post' onSubmit={createUser}>
            <div className='popup__header pretty'>
                <div className="d-flex w-100">
                    Crear Usuario

                    <button
                        type='button'
                        className='btn float-left my-auto ml-auto'
                        onClick={toggle}>
                        <i className="fas fa-times" style={{color: '#777'}}></i>
                    </button>
                </div>
            </div>
            <div className='popup__body pretty'>
                <Form usuario={usuario} errors={errors} sucursales={sucursales} almacenes={almacenes} cuentas={cuentas} />
            </div>
            <div className='popup__footer'>
                <button
                    type='button'
                    onClick={toggle}
                    className='btn btn-plain btn-pretty'>
                    Cancelar
                </button>
                <button type='submit' className='btn btn-primary btn-pretty'>
                    Crear
                </button>
            </div>
        </form>
    );
};

export default Create;
